import { render } from "./SpinnerLoader.vue?vue&type=template&id=5db66759&scoped=true"
const script = {}

import "./SpinnerLoader.vue?vue&type=style&index=0&id=5db66759&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db66759"]])

export default __exports__